export type DateDefinition = {
  day: string;
  month: string;
  year: string;
};

export const generateDates = (startDate: number, endDate: number, type: 'increment' | 'decrement', count = 1) => {
  const arrayNumbers = Array.from(
    { length: Math.floor((endDate + 1 - startDate) / count) },
    (_, i) => `${startDate + i * count}`,
  );
  if (type === 'decrement') {
    return arrayNumbers.reverse();
  }
  return arrayNumbers;
};

export const getMaxBirthDateForMinimumAge = (minimumAge: number, referenceDate = new Date()): Date => {
  const maxBirthDate = new Date(referenceDate);
  maxBirthDate.setFullYear(maxBirthDate.getFullYear() - minimumAge);
  return maxBirthDate;
};

export const getBirthDateYearsList = (maxBirthDate: Date, minYear = 1940): Array<string> => {
  return generateDates(minYear, maxBirthDate.getFullYear(), 'decrement');
};

export const getBirthDateMonthsList = (
  maxBirthDate: Date,
  selectedYear: string,
  months: Array<string>,
): Array<string> => {
  if (Number(selectedYear) < maxBirthDate.getFullYear()) {
    return months;
  }

  return months.slice(0, maxBirthDate.getMonth() + 1);
};

export const getBirthDateDaysList = (
  maxBirthDate: Date,
  selectedYear: string,
  selectedMonth: string,
  months: Array<string>,
): Array<string> => {
  const allDays = generateMonthDays(selectedMonth, selectedYear);
  const maxYear = maxBirthDate.getFullYear();
  const maxMonth = months[maxBirthDate.getMonth()];

  if (Number(selectedYear) < maxYear || selectedMonth !== maxMonth) {
    return allDays;
  }

  return allDays.filter((day) => Number(day) <= maxBirthDate.getDate());
};

export const clampBirthDateObject = (
  date: DateDefinition,
  maxBirthDate: Date,
  months: Array<string>,
): DateDefinition => {
  const allowedYears = getBirthDateYearsList(maxBirthDate);
  const year = allowedYears.includes(date.year) ? date.year : allowedYears[0];

  const allowedMonths = getBirthDateMonthsList(maxBirthDate, year, months);
  const month = allowedMonths.includes(date.month) ? date.month : allowedMonths[allowedMonths.length - 1];

  const allowedDays = getBirthDateDaysList(maxBirthDate, year, month, months);
  const day = allowedDays.includes(date.day) ? date.day : allowedDays[allowedDays.length - 1];

  return { year, month, day };
};

const isLeapYear = (year: number): boolean => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const generateMonthDays = (month: string, year: string): Array<string> => {
  let currentMonthDays: number;
  switch (month) {
    case 'Jan':
    case 'Mar':
    case 'May':
    case 'Jul':
    case 'Aug':
    case 'Oct':
    case 'Dec':
      currentMonthDays = 31;
      break;
    case 'Apr':
    case 'Jun':
    case 'Sep':
    case 'Nov':
      currentMonthDays = 30;
      break;
    case 'Feb':
      currentMonthDays = 28;
      break;
    default:
      currentMonthDays = 31;
  }

  if (month === 'Feb' && isLeapYear(parseInt(year, 10))) {
    return generateDates(1, 29, 'increment');
  }
  return generateDates(1, currentMonthDays, 'increment');
};
